module.exports = __webpack_public_path__ + "static/media/requests.79df8835.png";